/**
 * 『コマ割』画面の受渡用VO
 *
 * @export KYMW1404InputModel
 * @class KYMW1404InputModel
 */
export class KYMW1404InputModel {
  /**
   * 処理区分
   * 1:画面表示要求、2:コマ割画面の更新完了後(再表示要求)
   */
  public processDiv = Number(0);

  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 会員生協コード
   */
  public coopCode = String('');

  /**
   * ページ番号
   */
  public pageNum = String('');

  /**
   * 編集モード
   * 0:編集可、1:編集不可(ロック時)
   */
  public editMode = String('');

  /**
   * アクティブコマ有無フラグ
   * 0:なし、1:あり(コマ選択時)
   */
  public activeKomaFlag = Number(0);

  /**
   * 注文商品区分
   * 01:通常注文商品、02:いつでも注文商品
   */
  public orderGoodsFlg = String('01');

  /**
   * 業態区分
   * 1:ウィークリー、2:デイリー、3：スポット、0：期間
   */
  public dutiesFormDiv = String('1');
}
